import React, { createContext, useState } from 'react'

export const NotificationContext = createContext()

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([])
  const [issueNotifications, setIssueNotifications] = useState([])

  const addJobNotification = (job) => {
    setNotifications((prev) => [...prev, job])
  }

  const updateJobNotification = (jobId, updates) => {
    setNotifications((prev) =>
      prev.map((notif) =>
        notif.id === jobId ? { ...notif, ...updates } : notif
      )
    )
  }

  const addIssueNotification = (issue) => {
    const notification = {
      id: `issue-${issue.id}-${Date.now()}`,
      type: 'issue',
      title: `${issue.priority} Priority Issue`,
      message: `${issue.title} - ${issue.plantName}`,
      issueId: issue.id,
      plantId: issue.plantId,
      priority: issue.priority,
      timestamp: new Date().toISOString(),
      read: false,
    }
    setIssueNotifications((prev) => [notification, ...prev])
  }

  const markIssueNotificationRead = (notificationId) => {
    setIssueNotifications((prev) =>
      prev.map((notif) =>
        notif.id === notificationId ? { ...notif, read: true } : notif
      )
    )
  }

  const clearIssueNotifications = () => {
    setIssueNotifications([])
  }

  return (
    <NotificationContext.Provider
      value={{
        notifications,
        addJobNotification,
        updateJobNotification,
        issueNotifications,
        addIssueNotification,
        markIssueNotificationRead,
        clearIssueNotifications,
      }}
    >
      {children}
    </NotificationContext.Provider>
  )
}

export default NotificationProvider
